import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { PromotionBanner } from "@src/appV2/redesign/system/ui-components";
import { useHistory } from "react-router-dom";

import { SKILLS_ASSESSMENT_BASE_PATH } from "../../SkillsAssessment/paths";

interface Props {
  title: string;
}

export function OrientationBanner(props: Props) {
  const { title } = props;
  const history = useHistory();

  const handleClick = () => {
    logEvent(APP_V2_USER_EVENTS.CLIPBOARD_ORIENTATION_MY_ACCOUNT_BANNER_CLICKED, {
      title,
    });
    history.push(SKILLS_ASSESSMENT_BASE_PATH);
  };

  return (
    <PromotionBanner
      title={title}
      backgroundColor={(theme) => theme.palette.common.white}
      borderColor={(theme) => theme.palette.placement!.interviewDay.feature.gradient}
      icon="calendar-with-circle-colored"
      borderVariant="gradient"
      onClick={handleClick}
    />
  );
}
